import React from 'react';
import { isStandaloneApp } from 'app/utils/browser';
// @ts-ignore
import zelenikaImgPath from './img/zelenika.jpg';
import ahmadImgPath from './img/ahmad.png';
// @ts-ignore
import bonImgPath from './img/bon.jpg';
// @ts-ignore
import apolloImgPath from './img/apollo.jpg';
// @ts-ignore
import tefal from './img/tefal.jpg';
import css from './giftDishCard.module.scss';

type GiftDishId = 'ahmad' | 'zelenika' | 'bon999' | 'bon1100' | 'hurry' | 'apollo' | 'pancake' | 'tefal' | 'bon1111';

interface GiftDishContent {
    image: string;
    title: React.ReactNode;
    description: React.ReactNode;
}

interface GiftDishCardProps {
    id: GiftDishId;
}

const contentMap: Record<GiftDishId, GiftDishContent> = {
    ahmad: {
        image: ahmadImgPath,
        title: (
            <>
                Подарок
                <br />
                от Ahmad Tea
            </>
        ),
        description: 'при заказе любого блюда',
    },
    zelenika: {
        image: zelenikaImgPath,
        title: 'Хрустящий подарок',
        description: (
            <>
                от Зеленики в
                {' '}
                <a
                    href="https://elmntr.ee/terms"
                    target={isStandaloneApp() ? undefined : '_blank'}
                    className={css.giftDishCardDescLink}
                    rel="noreferrer"
                >
                    доставках
                </a>
                <br />
                с 15 по 21 сентября
            </>
        ),
    },
    bon999: {
        image: bonImgPath,
        title: 'Дарим 993 бонуса!',
        description: (
            <>
                используйте их на заказ
                <br />
                от 3 000 ₽ до 17 июля
            </>
        ),
    },
    bon1100: {
        image: bonImgPath,
        title: 'Ого! У вас 1100₽ бонусов!',
        description: (
            <>
                используйте до 17 июля
                <br />
                на заказ от 3 000 ₽
            </>
        ),
    },
    hurry: {
        image: bonImgPath,
        title: '1100 бонусов сгорят 18.07',
        description: (
            <>
                успейте потратить
                <br />
                на сет недели
            </>
        ),
    },
    apollo: {
        image: apolloImgPath,
        title: 'Полезный подарок',
        description: (
            <>
                <a
                    href="https://drive.google.com/file/d/1QOWd6SJMDkfpOfkGAgDNKV1D_cmIeWD4/view?usp=sharing"
                    target={isStandaloneApp() ? '_self' : '_blank'}
                    rel="noreferrer"
                    style={{ textDecoration: 'underline' }}
                >
                    при заказе от 5 000 ₽
                </a>
                <br />
                с 24 июля по 7 августа 26
            </>
        ),
    },
    pancake: {
        image: bonImgPath,
        title: 'ПАНКЕЙКИ - В ПОДАРОК!',
        description: (
            <>
                *при заказе сета недели
            </>
        ),
    },

    tefal: {
        image: tefal,
        title: 'Подарки от Tefal',
        description: (
            <>
                Закажите хэллоуин-бокс
                <br />
                — получите шанс выиграть
                <br />
                <a
                    href="https://drive.google.com/file/d/1NTfK4Ay5upS46uP8ib__-fC-SoOuXNo6/view?usp=sharing"
                    target={isStandaloneApp() ? '_self' : '_blank'}
                    rel="noreferrer"
                    style={{ textDecoration: 'underline' }}
                >
                    аэрогриль и другие призы
                </a>
            </>
        ),
    },
    bon1111: {
        image: bonImgPath,
        title: 'Дарим 1111 бонусов',
        description: (
            <>
                Используйте до 07.11
            </>
        ),
    },
};

export const GiftDishCard: React.FC<GiftDishCardProps> = ({ id }) => {
    const content = contentMap[id] || contentMap.zelenika;

    return (
        <div className={css.giftDishCardRoot}>
            <div className={css.giftDishCardLeft}>
                <img src={content.image} alt="" className={css.giftDishCardImg} />
            </div>
            <div className={css.giftDishCardRight}>
                <div className={css.giftDishCardTitle}>
                    {content.title}
                </div>
                <div className={css.giftDishCardDesc}>
                    {content.description}
                </div>
            </div>
        </div>
    );
};
